<template>  
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>  
        <v-layout row>
          <v-flex xs12 md12>
            <form @submit.prevent="onsubmit">          
              <v-card>                    
                <v-toolbar flat dense color="cyan">
                  <v-spacer />
                  <v-btn :disabled="submit_disabled" type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
                </v-toolbar>
                <v-card-text>           
                  <v-layout row>
                    <v-flex xs12 md3>
                      <v-text-field outlined dense
                        label="Code"
                        v-model="fm.name"
                        append-icon="grade"
                        type="text"
                        :error="!!error.name.length"
                        :error-messages="error.name"
                      ></v-text-field>  
                      <v-text-field outlined dense
                        label="Name"
                        v-model="fm.description"
                        append-icon="description"
                        type="text"
                        :error="!!error.description.length"
                        :error-messages="error.description"
                      ></v-text-field>           
                    </v-flex>
                    <!--<v-flex xs12 md3>
                      <v-autocomplete outlined dense
                        v-model="fm.node_id"
                        label="Area"
                        :items="nodes"
                        item-text="name"
                        item-value="id"
                        :loading="nodeLoading"
                        @keyup="search"
                      >                    
                        <template v-slot:item="data">                
                          <template>
                            <v-list-item-content>
                              <v-list-item-title v-html="data.item.name"></v-list-item-title>
                              <v-list-item-subtitle>{{ data.item.parent_name }}</v-list-item-subtitle>
                              <v-list-item-subtitle><strong>TINGKAT : {{ data.item.levelText }}</strong></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>                                                                    
                      <v-text-field
                        outlined dense
                        label="Distribusi Questionnaire"
                        v-model="fm.lembar"
                        suffix="lembar"
                        type="number"
                        :error="!!error.lembar.length"
                        :error-messages="error.lembar"
                      >
                      </v-text-field>
                    </v-flex>-->
                    <v-flex xs12 md3>
                      <v-menu
                        v-model="colorpicker"              
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y              
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field outlined dense                  
                            v-model="fm.color"
                            label="Color"
                            append-icon="invert_colors"                  
                            v-on="on"
                            style="width:200px;"
                            :background-color="fm.color"
                            hide-details
                          ></v-text-field>
                        </template>
                        <!--<v-color-picker v-model="fm.color"></v-color-picker>-->                
                      </v-menu>                  
                      <v-switch v-model="fm.status" :label="fm.status === 1?'Status:Active':'Status:Inactive'" :true-value="1" :false-value="0"></v-switch>   
                      
                    </v-flex>
                    <v-flex xs12 md3>
                      <v-checkbox v-model="fm.node_id" :value="-1" label="soal ujian" />  
                      <template v-if="fm.node_id==-1" >
                        <v-select label="Tingkat" :items="[
                          {id:1, name:'SD'},
                          {id:2, name:'SMP'},
                          {id:4, name:'MA IPA'},
                          {id:5, name:'MA IPS'},
                          {id:6, name:'MA AGAMA'},
                        ]"
                        v-model="fm.tingkat_id"
                        item-value="id"
                        item-text="name"
                        style="width:200px;" />                             
                      </template>  
                    </v-flex>
                    <v-flex xs12 md3>
                      <template v-if="fm.node_id==-1" >                        
                        <v-text-field type="number" v-model="fm.waktu" style="width:200px;" label="waktu" suffix="menit" />
                        <v-text-field
                          label="Start Time"
                          v-model="fm.dtime_start"                          
                          type="datetime-local"
                          ></v-text-field> 
                      </template>  
                    </v-flex>
                  </v-layout>
                </v-card-text>  
                <v-toolbar color="cyan lighten-4" flat dense>
                  <h3>Quetionnaire</h3><v-spacer/>
                  <v-autocomplete 
                    hide-details 
                    v-model="template_id" 
                    autocomplete="off" 
                    :items="templates"
                    item-text="description"
                    item-value="id"
                    :loading="templateLoading"
                    @keyup="searchQuetionnaire" 
                    outlined dense 
                    class="mr-2" style="max-width:150px" 
                    label="Load Template"
                  >
                  </v-autocomplete>
                  <v-btn small fab dark color="green" @click="addQuetion"><v-icon>add</v-icon></v-btn>             
                </v-toolbar>
                <v-card-text>
                  <template v-for="(quetion, i) in fm.quetionnaires">
                    <v-layout row wrap :key="i" :class="i%2==0?'':'grey lighten-3'">                
                       <v-flex xs3 md1>
                        <v-text-field outlined dense
                          label="No"
                          v-model="quetion.no"
                          type="number"           
                          hide-details        
                          autocomplete="off"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md11 v-if="fm.node_id == -1">
                        <v-layout row wrap>
                          <v-flex xs12 md3 v-if="quetion.image">
                            <v-card >                              
                              <v-btn small absolute round left class="mt-2" style="z-index:2" rounded dark color="cyan" @click="img.dialog = true; img.no = i; img.src=null; img.title='Upload Image'"><v-icon left>camera</v-icon> Open Gallery</v-btn>                            
                              <v-btn small absolute right class="mt-2"  style="z-index:2" dark color="red" flat icon @click="quetion.image=null; delete cropImg[i]"><v-icon left>close</v-icon></v-btn>                            
                              <template v-if="cropImg[i] || quetion.image">
                                <img v-if="cropImg[i]" :src="cropImg[i]" class="mx-auto" style="width:100%"  />
                                <img v-else-if="quetion.image" :src="$config.url+'cdn/img/questionnaire/'+quetion.image" class="mx-auto" style="width:100%"  />                                                            
                              </template>                                                                                         
                              <v-icon v-else size="200">image</v-icon><br/>                                     
                            </v-card>                            
                          </v-flex>

                          <v-flex xs12 md3 v-else>
                            <v-card>                              
                              <v-btn small absolute round left class="mt-2"  style="z-index:2" rounded dark color="cyan" @click="img.dialog = true; img.no = i; img.src=null; img.title='Upload Image'"><v-icon left>camera</v-icon> Open Gallery</v-btn>                            
                              <v-btn small absolute v-if="cropImg[i]" right class="mt-2"  style="z-index:2" dark color="red" flat icon @click="delete cropImg[i]"><v-icon left>close</v-icon></v-btn>                            
                              
                              <template v-if="cropImg[i]">
                                <img v-if="cropImg[i]" :src="cropImg[i]" class="mx-auto" style="width:100%" />                                                                                         
                              </template>                                                                                         
                              <v-icon v-else size="50">image</v-icon><br/>                                     
                            </v-card>                            
                          </v-flex>

                          <!--<v-flex xs12 md3>
                            <v-select outlined dense 
                              label="Group"
                              v-model="quetion.group"
                              type="text"          
                              hide-details 
                              :items="groups"
                              item-text="name"
                              item-value="id"
                              style="max-width:200px"
                              />
                          </v-flex>-->
                        </v-layout>  
                      </v-flex>                     
                      <v-flex xs8 md10>
                        <v-text-field outlined dense
                          label="Question"
                          v-model="quetion.question"
                          type="text"          
                          hide-details   
                          autocomplete="off"                      
                        ></v-text-field>
                      </v-flex>      
                      <v-flex xs1 md1>
                        <v-btn style="float:right" @click="delQuetion(i)" small icon dark color="red"><v-icon>delete</v-icon></v-btn>             
                      </v-flex>                      
                      <v-flex xs12 md12>
                        <v-radio-group v-model="quetion.type" label="type :" class="mt-0" row hide-details>
                          <v-radio :label="`Optional`"   :value="1"></v-radio>
                          <v-radio :label="`Additional`" :value="2"></v-radio>                    
                          <v-radio :label="`Isian`"      :value="3"></v-radio>
                        </v-radio-group>
                      </v-flex>    
                      <v-flex xs12 md7 style="position:relative">
                        <v-btn icon small color="blue" style="position:absolute; right:25px" @click="addOption(quetion)"><v-icon>add</v-icon></v-btn>
                        <v-data-table dense 
                          :headers="headers"
                          :items="Array.isArray(quetion.option)?quetion.option:[]"              
                          :loading="loading"
                          loading-text="Loading... Please wait"
                          :items-per-page="-1"
                          hide-default-footer  
                          hide-actions
                          class="elevation-1"                        
                          :mobile-breakpoint="0"                
                        >        
                          <template slot="items" slot-scope="props">                         
                            <td>{{ props.item.id = props.item.id ? props.item.id : (quetion.option.findIndex(x=>x==props.item)+1) }}</td>
                            <td><v-text-field class="mt-0 pt-0" dense hide-details v-model="props.item.key" placeholder="type key here"></v-text-field></td>  
                            <td><v-text-field class="mt-0 pt-0" dense hide-details v-model="props.item.value"  placeholder="type value here"></v-text-field></td>  
                            <td>
                              <v-btn icon small color="red" @click="delOption(quetion, props.item)"><v-icon>close</v-icon></v-btn>                          
                            </td>
                          </template>                                 
                        </v-data-table>                  
                      </v-flex>    
                      <v-flex xs6 md3 v-if="fm.node_id == -1">
                        <v-text-field outlined dense 
                          label="Kunci"
                          v-model="quetion.kunci"
                          type="number"          
                          hide-details   
                          style="max-width:100px"
                          autocomplete="off"/>
                      </v-flex>  
                    </v-layout>                                                 
                  </template>  
                </v-card-text>
                <v-card-actions class="pa-4">
                  <v-spacer />
                  <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
                </v-card-actions>
              </v-card>
            </form>   
          </v-flex>            
        </v-layout>
      </v-container>
      <v-dialog v-model="img.dialog" persistent max-width="700px">
        <v-card>
          <v-card-title class="title">{{img.title}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2"> 
            <div>           
              <input type="file" name="image" accept="image/*" ref="ktp" style="display:none; font-size: 1.2em; padding: 10px 0;" @change="setImage" />
              <v-btn small class="mr-4 mb-4" color="blue" dark @click="$refs.ktp.click()" :loading="img.fileLoading"><v-icon>collections</v-icon> select image</v-btn>
              <v-btn icon class="mb-4" small color="blue-grey" dark fab @click="rotate" v-if="img.src"><v-icon>rotate_right</v-icon></v-btn>              
            </div>
            <div style="width: 100%; min-height:300px; border: 1px solid gray; display: inline-block;">
              <div :style="img.src ? '':'display:none'">                  
                <vue-cropper 
                    ref='cropper'
                    :guides="true"
                    :view-mode="2"
                    drag-mode="crop"                      
                    :auto-crop-area="1"
                    :cropBoxResizable="true"                                       
                    :min-container-width="352"
                    :min-container-height="140"
                    :background="true"
                    :rotatable="true"
                    :src="img.src"
                    alt="Source Image"
                    :img-style="{ 'width': '600px', 'height': '400px' }">
                </vue-cropper>                
              </div>  
            </div>                            
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="img.dialog=false">Close</v-btn>              
            <v-btn color="success" :loading="img.croploading" @click="cropImage();" v-if="img.src">Crop & Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>         
    </div>
  </v-slide-y-transition>    
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/master/Quetionnaire'
const  model = new Model();

import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css';


export default {
  components: {VueCropper},
  data : () => ({  
    fm:{ name: null, node_id:null, tingkat_id:null, description:null, waktu:null, color:'#fff', lembar:null, status:1, quetionnaires:[], dtime_start:null},
    error:{ name : [], node_id:[], tingkat_id:[], description:[], waktu:[], color:[], lembar:[], status:[], quetionnaires:[]},
    headers: [
      {text:'No', value:'no', sortable:false, width:70},
      {text:'Key', value:'key', sortable:false, width:180},
      {text:'Value', value:'value', sortable:false, width:300},
      {text:'', value:'action', width:50, sortable:false},
    ],
    groups:[],
    items:[],
    loading: false,
    isUpdate: false,    
    mode: 0,        
    nodes: [], nodeLoading:false,
    colorpicker:false,
    importTypes:['calon','partai'],
    img:{
      dialog : false, cropLoading : false,
      src : null, fileLoading : false, no : 0,
    },
    cropImg: {},
    blobImg: {},
    template_id:null, templates:[], templateLoading:false,
    submit_disabled :true
  }),
  computed:{
    
  },
  watch:{
    'fm.node_id'(newId, oldId){
      if(oldId===null && newId !== null){
        /*model.node({id:newId}).then(data=>{
          this.nodes.push(data);
        })*/    
      }
    },
    'fm.tingkat_id'(newId){
      if(newId){
        model.settings({key:'ujian_'+newId}).then(data=>{          
          this.groups = data.value;
        })
      }
    },
    template_id(newId){
      if(newId){
        let jil = this.templates.find(x=>x.id==newId);
        if(jil){
          if(Array.isArray(jil.quetionnairesKunci)){
            jil.quetionnairesKunci.map(r=>{
              delete r.id 
              r.jilid_id = null
              return r;
            })
          }
          console.log(jil.quetionnairesKunci);
          this.fm.quetionnaires = jil.quetionnairesKunci;
        }
      }
    }
  }, 
  mounted(){
    if(this.$route.query.id){
      this.isUpdate = true;
      model.view({id:this.$route.query.id, expand:'quetionnairesKunci'}).then(data=>{                
        Object.assign(this.fm, data);
        this.fm.quetionnaires = data.quetionnairesKunci
        this.fm.quetionnairesKunci = null;
        this.fm.area_id = String(this.fm.area_id);

        setTimeout(()=>{this.submit_disabled = false}, 7000)
      })
    }
    this.searchQuetionnaire({target:{value:''}})    
  },
  methods: {    
    search: debounce(function (e) {      
      this.readNodes(e.target.value)
    }, 800),

    searchQuetionnaire: debounce(function (e) {      
      this.templateLoading = true;
      model.all({q:e.target.value,expand:'quetionnairesKunci'}).then(res=>{
        this.templates = res.data;
        this.templateLoading = false;
      });
    }, 400),

    readNodes(term){
      this.nodeLoading = true;
      model.nodes({q:term,level:this.fm.tingkat}).then(res=>{
        this.nodes = res.data;
        this.nodeLoading = false;
      })
    },

    importdata(e, quetion){
      model.importdata({type:e, kompetisi_id:quetion.kompetisi_id}).then(data=>{        
        if(Array.isArray(data)){
          quetion.option = [];
          data.forEach(item=>{
            quetion.option.push({id:item.id,key:item.no,value:item.name});
          })
        }        
      })
    },
    
    addQuetion(){      
      let no = this.fm.quetionnaires.length + 1;
      this.fm.quetionnaires.push({no:no, question:null, type:1, option:[]})
    },

    delQuetion(i){
      this.fm.quetionnaires.splice(i, 1);
    },

    addOption(quetion){
      if(!Array.isArray(quetion.option)){
        quetion.option = [];
      }
      quetion.option.push({id:null, key:null, value: null});
    },

    delOption(quetion, item){
      quetion.option.splice(quetion.option.findIndex(x=>x===item), 1);
    },

    onsubmit(){
      this.loading = true;  this.clearErrors();

      var FormData = require('form-data');
      let formData = new FormData();                
      this.buildFormData(formData, this.fm);

      for(var i in this.blobImg){
        let file = new File([this.blobImg[i]], i, { type: "image/jpeg", lastModified: Date.now() });
        formData.append('file_image['+i+']', file, file.name);
      }
      
      if(this.isUpdate){        
        model.update(formData, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(formData).then(res=>{this.responseSubmit(res)})
      }
    },

    responseSubmit(res){
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
        this.$router.replace({name:'adm/quetionnaire'})                
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.name    = [];
      this.error.type    = [];
      this.error.address = [];
      this.error.email   = [];
      this.error.node_id = [];      
    },

    buildFormData(formData, data, parentKey) {
      if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        if(Array.isArray(data) && data.length == 0){
          formData.append(parentKey, []);
        } else {
          Object.keys(data).forEach(key => {
          this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
        }        
      } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
      }
    },

    setImage(e) {      
      /*if(this.img.no == 0){
        this.$refs.cropper.setAspectRatio(200/200);
      } else {
        this.$refs.cropper.setAspectRatio(352/140);
      }*/
      
      const file = e.target.files[0];
      console.log(e.target.files[0]);
      if (!file.type.includes('image/')) {
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        this.img.fileLoading = true;
        reader.onload = (event) => {
          this.img.src = event.target.result;
          this.$refs.cropper.replace(event.target.result);
          this.img.fileLoading = false;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }      
    },
      
    cropImage() {            
      this.img.croploading = true;
      setTimeout(()=>{
          this.cropImg[this.img.no] = this.$refs.cropper.getCroppedCanvas().toDataURL();
          this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
            this.blobImg[this.img.no] = blob;
          });
          this.img.dialog  = false;
          this.img.croploading = false;
      }, 300);                
    },

    rotate() {      
      this.$refs.cropper.rotate(90);
    },
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
.v-data-table-header-mobile__wrapper .v-select {
    max-width:200px !important;
}
</style>